/*
 * Mejora (opcional) para el header "Rep The Mission" del home.
 *
 * TODO lo visual —layout de 2 columnas, la linea divisoria y las animaciones de
 * entrada (fade + subida + linea que se dibuja)— ya vive en assets/custom.css y
 * corre solo. Este archivo NO es necesario para que la seccion se vea bien.
 *
 * Lo unico que hace: partir el <h1> en caracteres (respetando los <br>) para el
 * efecto letra-por-letra del Webflow de Hermeus (/aircraft), y marcar la seccion
 * con la clase `.stagger-active` para que custom.css anime cada caracter en vez
 * del bloque completo. Sin este JS, el <h1> igual entra con fade + subida.
 *
 * Scope: el wrapper cuyo id contiene "section_wBFGai". OJO: Shopify renderiza
 * el id como `shopify-section-template--<num>__section_wBFGai`, con un prefijo
 * numerico de plantilla que cambia si se recrea el template; por eso matcheamos
 * por substring (SECTION_KEY), igual que el selector [id*='section_wBFGai'] en
 * custom.css. Si se renombra/duplica la seccion, actualizar SECTION_KEY aca y el
 * selector en custom.css.
 */
(function () {
  'use strict';

  var SECTION_KEY = 'section_wBFGai';

  // Con reduce motion no partimos el titulo: se muestra tal cual.
  if (
    window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches
  ) {
    return;
  }

  function splitHeading(h1) {
    var rawLines = h1.innerHTML.split(/<br\s*\/?>/i);
    var label = h1.textContent.replace(/\s+/g, ' ').trim();

    h1.textContent = '';
    h1.setAttribute('aria-label', label);

    var index = 0;
    rawLines.forEach(function (lineHtml) {
      var probe = document.createElement('div');
      probe.innerHTML = lineHtml;
      var text = probe.textContent;

      var line = document.createElement('span');
      line.className = 'stagger-line';
      line.setAttribute('aria-hidden', 'true');

      for (var i = 0; i < text.length; i++) {
        var ch = document.createElement('span');
        ch.className = 'stagger-char';
        ch.style.setProperty('--i', index);
        ch.textContent = text.charAt(i);
        line.appendChild(ch);
        index++;
      }
      h1.appendChild(line);
    });
  }

  function run(root) {
    var section =
      root && root.id && root.id.indexOf(SECTION_KEY) !== -1
        ? root
        : document.querySelector('[id*="' + SECTION_KEY + '"]');
    if (!section || section.classList.contains('stagger-active')) return;

    var h1 = section.querySelector('.custom-section-content .text-block h1');
    if (!h1) return;

    splitHeading(h1);
    section.classList.add('stagger-active');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      run(document);
    });
  } else {
    run(document);
  }

  // Theme editor: re-procesar solo esta seccion al recargarla/moverla.
  document.addEventListener('shopify:section:load', function (event) {
    if (
      event.target &&
      event.target.id &&
      event.target.id.indexOf(SECTION_KEY) !== -1
    ) {
      run(event.target);
    }
  });
})();
